var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_vm._v(" "),(_vm.blogpost)?_c('blogpostpanel',{attrs:{"blogpost":_vm.blogpost}}):_vm._e(),_vm._v(" "),_vm._m(1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{attrs:{"id":"blog-header"}},[_c('div',{staticClass:"inner"},[_c('nav',{attrs:{"id":"navigation"}},[_c('span',{staticClass:"blog-logo"})])])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner"},[_c('div',{attrs:{"id":"disqus_thread"}})])
}]

export { render, staticRenderFns }